import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { GeneralService } from 'src/app/services/general/general.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { DateRange } from 'src/app/interfaces/date-range.interface';
import { EventApi } from '@fullcalendar/angular';

@Component({
  selector: 'app-booking-dialog',
  templateUrl: './booking-dialog.component.html',
  styleUrls: ['./booking-dialog.component.scss'],
})
export class BookingDialogComponent implements OnInit {
  public form: FormGroup;
  public options = new Array();

  constructor(
    public dialogRef: MatDialogRef<BookingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public general: GeneralService,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      start: ['', [Validators.required]],
    });

    this.fillOptions();
  }

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }

  sendForm() {
    this.dialogRef.close({ start: this.form.value.start, end: this.getEnd()});
  }

  fillOptions() {
    let start: DateTime = this.data.start;
    let end: DateTime = this.data.end;
    let tmpStart: DateTime = start;
    let diff = end.diff(tmpStart, 'minutes').minutes;

    this.form.patchValue({
      start: tmpStart,
    });

    while (diff >= 59) {
      this.options.push({
        date: tmpStart,
        str: tmpStart.setZone(this.data.timezone).toFormat('T'),
        end: tmpStart.plus({ minutes: diff > 59 ? 60 : 59 }),
      });
      tmpStart = tmpStart.plus({ minutes: 30 });

      diff = end.diff(tmpStart, 'minutes').minutes;
    }
  }

  get end() {
    const end = this.getEnd();
    if (!end) return '';
    return end.setZone(this.data.timezone).toFormat('T');
  }

  getEnd(): DateTime | null {
    if (!this.form.value.start) return null;

    const option = this.options.find((opt) => {
      return opt.date === this.form.value.start;
    });

    return option.end;
  }
}
